import { baseRequest } from '../../utils/HttpClient';
import { ApiEndpoints } from '../../constants/ApiEndpoints';

export const uploadMedia = payload => {
  return baseRequest(ApiEndpoints.UPLOAD_MEDIA, payload, null, null, true, true, true, true);
};
